import $ from 'jquery';
import 'slick-carousel';
import MicroModal from 'micromodal';

import { TagManager } from '@dealersites/tag-manager/tag-manager';

import '../components/payment-calc/payment-calculations.js';
import { LocalGarage } from '../components/garage/local';

MicroModal.init();

$('.masonry-item')
  .each(function () {
    const $item = $(this);
    const srcUrl = $item.data('url');

    const galleryImage = new Image();

    galleryImage.onload = () => {
      $item.find('.js-vdp-gallery-item').removeClass('opacity-0');
      $item.removeClass(
        ' bg-[url(/content/themes/ford-oem-theme/assets/icons/custom/vdp-ford-placeholder-anim.svg)]'
      );
    };

    galleryImage.onerror = () => {};
    galleryImage.src = srcUrl;
  })
  .on('hover', function (e) {
    e.stopPropagation();
  });

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.get('click')) {
  $(`.${urlParams.get('click')}`).trigger('click');
}

// Gallery
const $vdpGallerySlider = $('.vdp-gallery-slider');
const $vdpCurrentSlide = $('.vdp-gallery-current-item');

$vdpGallerySlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-vdp-gallery-slider'),
  prevArrow: $('.slide-m-prev-vdp-gallery-slider'),
});

$vdpGallerySlider.on('setPosition', function (e, slick) {
  slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});

$vdpGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
  const current = (currentSlide ? currentSlide : 0) + 1;
  $vdpCurrentSlide.text(current);
});

// Gallery Carousel
$('.vdp-gallery-open').on('click', function () {
  MicroModal.show('modal-vdp-gallery');
  $vdpGallerySlider.slick('setPosition');
});

$('.js-vdp-gallery-item').on('click', function () {
  const item = $(this).data('index');
  $vdpGallerySlider.slick('slickGoTo', item);
  setTimeout(() => {
    MicroModal.show('modal-vdp-gallery');
    $vdpGallerySlider.slick('setPosition');
  }, 400);
});

// VDP CTAS (Left)

const $vdpCTASlider = $('.vdp-ctas-slider');
const $vdpCurrentCTASlide = $('.vdp-ctas-slider-current-item');

$vdpCTASlider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-vdp-ctas-slider'),
  prevArrow: $('.slide-m-prev-vdp-ctas-slider'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$vdpCTASlider.on('init reInit afterChange beforeChange', function (event, slick, currentSlide) {
  if (slick.slideCount > 1) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    $vdpCurrentCTASlide.text(current + '/' + slick.slideCount);
  }
});

// Window sticker button (Right)
if (dsp.windowSticker) {
  $('a[data-window-sticker-id]').each(async function() {
    const $link = $(this);
    const itemId = $link.data('window-sticker-id');

    $link.removeAttr('data-window-sticker-id');

    try {
      const { window_sticker_url } = await dsp.windowSticker.fetch(itemId);
      $link.attr('href', window_sticker_url);
    } catch (e) {
      console.error("Could not update window sticker URL", e);
    }
  });
}

// Similar Vehicles SLIDER

const $vdpSimilarSlider = $('.vdp-similar-slider');
const $vdpCurrentSimilarSlide = $('.vdp-similar-slider-current-item');

$vdpSimilarSlider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-vdp-similar-slider'),
  prevArrow: $('.slide-m-prev-vdp-similar-slider'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$vdpSimilarSlider.on('init reInit afterChange beforeChange', function (event, slick, currentSlide) {
  const current = (currentSlide ? currentSlide : 0) + 1;
  $vdpCurrentSimilarSlide.text(current + '/' + slick.slideCount);
});

// Garage related

const $garageCheckbox = $('.js-vdp-garage .compare-checkbox');
$garageCheckbox.on('change', function () {
  if ($(this).prop('checked')) {
    const model = $(this).data('model');
    const year = $(this).data('year');
    const status = $(this).data('status');

    const config = {
      onclick: {
        onclick: status + ':si:vehicle details:save',
        onclickLinkName: 'dc:' + status + ':si:vehicle details:content:action:save',
      },
    };

    if (year || model) {
      config.vehicle = {};
    }

    if (year) {
      config.vehicle.modelYear = year;
    }

    if (model) {
      config.vehicle.nameplate = model;
    }

    TagManager.trackEvent('global-onclick', config);
  }
});

function initGarageButton() {
  const itemId = $('[data-garage-toggle-id]').data('garageToggleId');
  const isInGarage = LocalGarage.has(itemId);
  syncGarageButton(isInGarage);
}

function syncGarageButton(isInGarage) {
  const $garageRemoveText = $('.js-garage-remove');
  const $garageAddText = $('.js-garage-add');

  if (isInGarage) {
    $garageRemoveText.removeClass('hidden');
    $garageAddText.addClass('hidden');
  } else {
    $garageRemoveText.addClass('hidden');
    $garageAddText.removeClass('hidden');
  }
}

$('[data-garage-toggle-id]').on('change', function () {
  const isInGarage = $(this).prop('checked');
  syncGarageButton(isInGarage);
});

initGarageButton();
